import { Trigger, Icon as SelectIcon } from '@radix-ui/react-select';
import { cva, VariantProps } from 'class-variance-authority';
import { ComponentPropsWithRef } from 'react';
import { cn } from '@/shared/lib/cn';
import { FormFieldState } from '@/shared/ui/form/types';
import { Icon } from '@/shared/ui/icon';
import './select.scss';

const selectTriggerVariants = cva('select__trigger', {
    variants: {
        variant: {
            default: undefined,
            secondary: 'select__trigger--secondary',
            rounded: 'select__trigger--rounded',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});

type Props = ComponentPropsWithRef<typeof Trigger> &
    VariantProps<typeof selectTriggerVariants> & {
        state?: FormFieldState;
    };
export const SelectTrigger = ({ className, state, children, variant, ...props }: Props) => (
    <Trigger
        data-testid="select-trigger"
        data-state={state}
        className={cn(
            selectTriggerVariants({ variant }),
            state === 'error' && 'select__trigger--error',
            className,
        )}
        {...props}
    >
        {children}
        <SelectIcon asChild>
            <Icon name="chevron-right" className="select__trigger-icon" />
        </SelectIcon>
    </Trigger>
);
SelectTrigger.displayName = 'SelectTrigger';
